import * as React from 'react';

import { InterpolationLayer } from '@longline/aqua-ui/map/layers/InterpolationLayer';
import { ParticlesLayer } from '@longline/aqua-ui/map/layers/ParticlesLayer';

import { ILayer } from "./types/ILayer";
import { ELayerType } from './types/ELayerType';

class LayerFactory {
  // Calculate distance between two coordinates in meters.
  static calcDist = (lon1: number, lat1: number, lon2: number, lat2: number): number => {
    const R = 6371e3; // metres
    const φ1 = lat1 * Math.PI/180; // φ, λ in radians
    const φ2 = lat2 * Math.PI/180;
    const Δφ = (lat2-lat1) * Math.PI/180;
    const Δλ = (lon2-lon1) * Math.PI/180;
    
    const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
              Math.cos(φ1) * Math.cos(φ2) *
              Math.sin(Δλ/2) * Math.sin(Δλ/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    
    const d = R * c; // in metres    
    return d;
  }

  static getLayer = (index: number, layer: ILayer): React.ReactNode => {
    let data;

    switch(layer.type) {
      case ELayerType.CurrentSpeed:
        data = layer.data.map(point => { return { latitude: point.lat, longitude: point.lng, u: point.value[0], v: point.value[1] }; });
        return <ParticlesLayer 
          key={index} 
          data={data}
          particles={layer.trail}
          density={layer.density}
          pointSize={layer.pointSize}
          delay={layer.delay}
          gradientStops={layer.gradient}
          minZoom={7}
        />
      default: // all interpolation layers
        data = layer.data.map(point => { return { latitude: point.lat, longitude: point.lng, value: point.value[0] }; });

        // Calculate average distance between points:
        /* const points: FeatureCollection<Point> = featureCollection(
          (data ?? [])
            .filter(dp => !isNaN(dp.value)) // Filter out any NaN values.
            .map((dp) => {
              return point([dp.longitude, dp.latitude], { 'v': dp.value })
            })
        );
        const polys: FeatureCollection<Polygon> = tin(points, 'v');

        let totalDist = 0;
        polys.features.forEach(p => {
          const a = p.geometry.coordinates[0][0];
          const b = p.geometry.coordinates[0][1];
          const c = p.geometry.coordinates[0][2];
          totalDist += this.calcDist(a[0], a[1], b[0], b[1]);
          totalDist += this.calcDist(a[0], a[1], c[0], c[1]);
          totalDist += this.calcDist(b[0], b[1], c[0], c[1]);
        });
        const avg = totalDist / (polys.features.length * 3);
        console.log("Distance", avg); */

        return <InterpolationLayer 
          key={index} 
          data={data} 
          levels={layer.contours} 
          contourThickness={layer.contourThickness}
          gradientStops={layer.gradient}
          minZoom={7}
        />
    }
  }
}

export { LayerFactory }
